import { HtmlViewer as HtmlComponent } from "../viewer/html-viewer";
var HtmlComponent_default = HtmlComponent;
export {
  HtmlComponent_default as default
};
//# sourceMappingURL=HtmlComponent.js.map
